import * as R from 'ramda';

export function isEmpty(value) {
  return R.isNil(value) || R.isEmpty(value);
}
